var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeeklyPredictionGreyArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1722 8.48647L7.58242 15.0738C7.52416 15.124 7.44983 15.1521 7.37149 15.1521H5.59358C5.44492 15.1521 5.37662 14.9673 5.48912 14.8708L12.5244 8.76371H0.768136C0.679743 8.76371 0.607422 8.69138 0.607422 8.60299V7.39763C0.607422 7.30924 0.679743 7.23692 0.768136 7.23692H12.5224L5.48711 1.12978C5.37461 1.03134 5.44291 0.848527 5.59157 0.848527H7.42974C7.46791 0.848527 7.50608 0.86259 7.53421 0.888705L15.1722 7.51415C15.2417 7.57463 15.2975 7.64932 15.3357 7.73319C15.3739 7.81706 15.3937 7.90815 15.3937 8.00031C15.3937 8.09248 15.3739 8.18357 15.3357 8.26744C15.2975 8.3513 15.2417 8.426 15.1722 8.48647Z",
    fill: "black",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeeklyPredictionGreyArrow);
export default __webpack_public_path__ + "static/media/weekly-prediction-grey-arrow.bb3ce999805d6f0e46b13ea261d7e19a.svg";
export { ForwardRef as ReactComponent };